import { render, staticRenderFns } from "./advantages.vue?vue&type=template&id=b7af9422&scoped=true"
import script from "./advantages.vue?vue&type=script&lang=js"
export * from "./advantages.vue?vue&type=script&lang=js"
import style0 from "./advantages.vue?vue&type=style&index=0&id=b7af9422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7af9422",
  null
  
)

export default component.exports